export const TableHeadingTR = `bg-gray-600 text-white  font-semibold uppercase`;
export const TableTH = `p-1 py-6 font-semibold  text-sm `;
export const TableBodyTR = `hover:bg-gray-200 duration-300 cursor-pointer`;
export const TableTD = `px-4 py-4 pl-6`;
